<script>
    import CodeSelectorManualASAConsult from "./CodeSelectorManualASAConsult.svelte";
    import CodeSelectorManualASASurgery from "./CodeSelectorManualASASurgery.svelte";
    import CodeSelectorManualASAModifier from "./CodeSelectorManualASAModifier.svelte";
    import CodeSelectorManualASAProcedures from "./CodeSelectorManualASAProcedures.svelte";
    import CodeSelectorManualASATime from "./CodeSelectorManualASATime.svelte";
    import CodeSelectorManualAsaClaimDelayHoursAndInvoiceCustomDueDate from "./CodeSelectorManualASAClaimDelayHoursAndInvoiceCustomDueDate.svelte";

    import { hasCardiacAsaCode } from "../../../helpers/asaHelper.svelte";

    export let itemProps = {},
        procedureName = "",
        doctorId = 0,
        selectedItems = [],
        holidaysInState = [],
        infoTypesMap = new Map(),
        modifierMap = new Map(),
        noDisplayModifierItems = [],
        updateItems = () => {},
        openNotification = () => {};

    // For Item Time Selector
    export let timeObj = {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: showSurgerySection =
        itemProps.billingType == 0 ||
        (isCardiacEncounter &&
            hasCardiacAsaCode(selectedItems) &&
            selectedItems.some(({ itemCode }) =>
                ["CA002", "CA004", "CA006", "CA008", "CA051", "CA070"].includes(
                    itemCode,
                ),
            ));

    $: showModifierSection =
        itemProps.billingType == 0 ||
        (isCardiacEncounter &&
            hasCardiacAsaCode(selectedItems) &&
            selectedItems.some(({ itemCode }) =>
                [
                    "CV060",
                    "CD560",
                    "CA002",
                    "CA004",
                    "CA006",
                    "CA008",
                    "CA051",
                    "CA070",
                ].includes(itemCode),
            ));

    $: showAdditionalProcedureSection =
        (isCardiacEncounter &&
            hasCardiacAsaCode(selectedItems) &&
            selectedItems.some(({ itemCode }) =>
                [
                    "CV060",
                    "CD560",
                    "CA002",
                    "CA004",
                    "CA006",
                    "CA008",
                    "CA051",
                    "CA070",
                ].includes(itemCode),
            )) ||
        (!isCardiacEncounter &&
            !selectedItems.some(
                ({ itemCode, infoRegion }) =>
                    notShowProceduresArr.includes(itemCode) ||
                    notShowProceduresArr.includes(infoRegion),
            ));

    $: showTimeSection =
        !isCardiacEncounter ||
        (hasCardiacAsaCode(selectedItems) &&
            selectedItems.some(({ itemCode }) =>
                [
                    "CV060",
                    "CD560",
                    "CA002",
                    "CA004",
                    "CA006",
                    "CA008",
                    "CA051",
                    "CA070",
                ].includes(itemCode),
            ));

    let procedureRef;

    const notShowProceduresArr = ["CA080", "Telehealth"];

    // HELPER FUNCTIONS
</script>

<div class="flex flex-1 flex-col gap-y-4 overflow-y-auto p-4 mr-[5px]">
    <div class="flex flex-1 gap-x-4">
        <div class="flex flex-col flex-1 gap-y-4">
            <CodeSelectorManualASAConsult
                {itemProps}
                defaultItems={infoTypesMap.get("Consults")}
                {selectedItems}
                {updateItems}
            />

            {#if showSurgerySection}
                <CodeSelectorManualASASurgery
                    {itemProps}
                    {doctorId}
                    {procedureName}
                    defaultItems={infoTypesMap.get("Surgery")}
                    {selectedItems}
                    {updateItems}
                    {openNotification}
                />
            {/if}
        </div>

        <div class="flex flex-col flex-1 gap-y-4">
            {#if showModifierSection}
                <CodeSelectorManualASAModifier
                    {itemProps}
                    defaultItems={infoTypesMap.get("Modifiers")}
                    {selectedItems}
                    {modifierMap}
                    {noDisplayModifierItems}
                    {updateItems}
                    {openNotification}
                />
            {/if}

            {#if showAdditionalProcedureSection}
                <CodeSelectorManualASAProcedures
                    bind:this={procedureRef}
                    bind:itemProps
                    defaultItems={infoTypesMap.get("AdditionalProcedures")}
                    {selectedItems}
                    {updateItems}
                />
            {/if}
        </div>
    </div>

    {#if showTimeSection}
        <CodeSelectorManualASATime
            bind:itemProps
            bind:timeObj
            {procedureRef}
            {selectedItems}
            {updateItems}
        />
    {/if}

 <!--    {#if itemProps.showClaimDelayHoursAndInvoiceCustomDueDate}
        <CodeSelectorManualAsaClaimDelayHoursAndInvoiceCustomDueDate
            bind:itemProps
        />
    {/if} -->
</div>
